module.exports = __webpack_public_path__ + "images/sichuan_banner02.jpg?c1731a80a61f412aaedc6c92203bec17";


//////////////////
// WEBPACK FOOTER
// ./src/images/active/sichuan_banner02.jpg
// module id = 193
// module chunks = 1